<script>
export default {
    name: "InvoiceDetails",
data(){
    return{
visitDetail:[],
age:0,
nationalId:0,
dateofAdmission:'',
dateofDischarge:'',
ward:'',
bed:'',
patient:{
    customerId:0},

    }
},
    props: {

        showModal: Boolean,
        invoice: Object,
        insuranceDetails:Object,
        organizations: Object,
    },
// mounted(){
//     this.getPatientVisitDetails();
// },
    computed: {

        totalInsuranceAmt() {

            if(!this.invoice.invoiceItems.length) return 0;
  this.getPatientVisitDetails();
            const filteredItems = this.invoice.invoiceItems.filter(invItem => invItem.insuranceAmountPaid);

            if(!filteredItems.length) return 0;

            const invItems = filteredItems.map(item => parseFloat(item.insuranceAmountPaid));

            return invItems.reduce((cost, accTotal) => cost + accTotal);
        }
//         ,
//         patientvisitdetals(){
//              if(!this.invoice.invoiceItems.length) return 0;
//              this.getPatientVisitDetails();
// const patientdetail=this.visitDetail;
// return patientdetail;
//         }
    },

    methods: {

        printInvoiceDetails() {
            let url = `/reports/accounts-finance/invoice-details/print`;
                 url += `?patientID=${this.invoice.patientID}`;
                url += `&invoiceNo=${this.invoice.invoice_No}`;

            window.open(url,
             '_blank', 
             `ReportPrint`
            );
        },

        printInvoiceReceipt() {
            
            //  let url = `/billing/receipt-invoice-insurance/print`;
            //       url += `/${this.invoice.patientID}/${this.invoice.invoice_No}`;
            //      url += `?postedBy=${this.invoice.postedBy}`;
                 let url = `/billing/receipt-invoice-organisation/print`;
                url += `/${this.invoice.patientID}/${this.invoice.invoice_No}/${this.invoice.organizationID}`;
                  url += `?postedBy=${this.invoice.postedBy}`;
            window.open(url,
             '_blank', 
             `InvoiceReceiptPrint`,
            );
        },
         getPatientVisitDetails() {
      let url = `Visits/GetSpecificPatientVisit`;

      return this.$http
        .get(`${url}?VisitId=${this.invoice.visitNo}`)
        .then((response) => {
          this.visitDetail = response.data;
         this.age= this.visitDetail.specificVisitRecord.age;
       this.nationalId= this.visitDetail.specificVisitRecord.nationalid;
       this.dateofAdmission= this.invoice.invoicingAdmissionDate||this.visitDetail.specificVisitRecord.admissionDate;
this.dateofDischarge= this.invoice.invoicingDischargeDate||this.visitDetail.specificVisitRecord.disschargeDate;
this.ward= this.visitDetail.specificVisitRecord.ward;
this.bed= this.visitDetail.specificVisitRecord.bed;
this.patient=this.visitDetail.specificVisitRecord;
        })
        .catch(() => {this.visitDetail=[]});
    },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="w-11/12 md:w-2/3">
  <template v-slot:title>
    <h5 class="font-bold text-base">Invoice Details </h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
          <div class="flex w-full border-t-dotted border-t-2 border-t-black-600">
                <h5 class="w-full font-bold text-center">INVOICE FOR TREATMENT 
              </h5>
            </div>
            <div class="w-full flex flex-row p-2 bg-gray-300 mt-2">
                <div class="flex-1 p-tiny">  
                    <h5 class="font-bold text-sm uppercase">Date:{{invoice.date | dateFormat}}</h5> 
                    
                </div>
                <div class="flex-1 p-tiny">
                   <h5 class="font-bold text-sm uppercase"> Invoice No: {{invoice.invoice_No}}</h5>
                </div>
            </div><div class="flex-1">
                    <div class="w-full flex flex-col content-start">
                       
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Invoice To</h5>
                        </div>
                        <!-- <div class="w-1/2 p-tiny">
                            <label for="grid-insurance" class="label-control">Main Insurance</label>
                            <select v-model.number="main" id="grid-insurance" class="input-control input-sm text-xs">
                                <option value="0">select main insurance</option>
                                <option v-for="insurance in invoiceLines.combinedPaymentnInvoiceDetails" 
                                    :key="insurance.organizationID" 
                                    :value="insurance.organizationID">{{insurance.organization}}</option>
                            </select>
                        </div> -->
                        <div class="w-1/2 p-tiny">
                             <h5 class="font-bold text-sm uppercase"> {{invoice.organization}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Address: {{insuranceDetails.postalAddress || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Contact: {{insuranceDetails.cellphone || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Scheme: {{insuranceDetails.scheme || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Package: {{insuranceDetails.package || `-`}}</h5>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start p-1">
                        <div class="flex-1 p-1">  
                            <h5 class="font-bold text-sm uppercase">Bill Details</h5>  
                        </div>
                        <div class="flex-1 p-tiny">

                            <h5 class="font-medium text-sm capitalize">Name: {{patient.names}}</h5> 
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">MRN:{{patient.customerId}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">OP: {{patient.opfileno || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">IP: {{patient.ipfileno || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">DOB: {{patient.dob | dateFormat}}</h5>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start p-1">
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Principal Details</h5>
                        </div>
                        <div class="flex-1 p-tiny">

                            <h5 class="font-medium text-sm capitalize">
                                Name: {{ organizations.patientName }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Member No:{{ organizations.memberno }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Member ID: {{ organizations.memberIDNo || `-` }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Employer: {{ organizations.employer || `-` }}</h5>
                        </div>
                    </div>
                </div> 
            <!-- <div class="w-full flex flex-wrap p-1">
            <div class="flex-1">
                <h5 class="w-full font-bold text-right">Date: 
               <span class="text-blue-800">{{ invoice.date|dateFormat }}</span></h5>
            </div>
            <div class="flex-1">
                <h5 class="w-full font-bold text-left pl-2">Ref/Invoice No: 
               <span class="text-blue-800">{{ invoice.invoice_No || `-` }}</span></h5>
            </div>
            </div> -->
           <!-- <div class="w-full flex flex-wrap p-1 border-t-dotted border-t-2 border-t-black-600">
            <div class="flex-1">
                <h5 class="w-full font-bold text-center">To: 
               <span class="text-blue-800">{{ invoice.organization||`-`}}</span></h5>
            </div> </div> -->
            <!-- <div class="w-full flex flex-wrap p-1 border-t-dotted border-t-2 border-t-black-600">
                <h5 class="w-full font-bold text-center">Patient  </h5>
            <div class="flex-1">
                <h5 class="w-full font-bold text-right">Name: 
               <span class="text-blue-800">{{ invoice.patient }}</span></h5>
            </div>
            <div class="flex-1">
                <h5 class="w-full font-bold text-center">OP File No: 
               <span class="text-blue-800">{{ invoice.opfileNo || `-` }}</span></h5>
            </div>
            <div class="flex-1">
                <h5 class="w-full font-bold text-left pl-2">IP File No: 
               <span class="text-blue-800">{{ invoice.ipfileNo || `-` }}</span></h5>
            </div> 
            <div class="flex-1">
                <h5 class="w-full font-bold text-left pl-2">Member No: 
               <span class="text-blue-800">{{ invoice.memberno || `-` }}</span></h5>
            </div><div class="flex-1">
                <h5 class="w-full font-bold text-left pl-2">Dependant : 
               <span class="text-blue-800">{{ invoice.principalOfDependant || `-` }}</span></h5>
            </div>
            
        </div> -->

         <!-- <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
                <h6 class="w-full font-bold text-center">Patient  </h6>
            <div class="flex-1">
                <h6 class="w-full font-bold text-left  pl-2">Name: 
               <span class="text-blue-800">{{ invoice.patient }}</span></h6>
            </div>
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">OP File No: 
               <span class="text-blue-800">{{ invoice.opfileNo || `-` }}</span></h6>
            </div>
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">IP File No: 
               <span class="text-blue-800">{{ invoice.ipfileNo || `-` }}</span></h6>
            </div>   <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Age: 
               <span class="text-blue-800">{{ age || `-` }}Yr(s)</span></h6>
            </div>
            
        </div>  -->
        <!-- <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
           <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">ID No: 
               <span class="text-blue-800">{{ nationalId || `-` }} </span></h6>
            </div> 
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Member No: 
               <span class="text-blue-800">{{ invoice.memberno || `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Dependant : 
               <span class="text-blue-800">{{ invoice.principalOfDependant || `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Claim No : 
               <span class="text-blue-800">-</span></h6>
            </div>
            </div> -->
            <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
           <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Ward: 
               <span class="text-blue-800">{{ ward || `-` }} </span></h6>
            </div> 
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Bed: 
               <span class="text-blue-800">{{bed|| `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Date Admitted : 
               <span class="text-blue-800">{{ dateofAdmission|dateFormat }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Date Discharged : 
               <span class="text-blue-800">{{dateofDischarge|dateFormat}}</span></h6>
            </div>
            </div>
        <div class="w-full overflow-auto">
            <table class="table table-bordered table-hover">
                <thead class="bg-blue-500 text-xs text-white">
                    <tr>
                        <th class="p-tiny">#</th>
                        <th class="p-tiny"  v-if="$root.checkAuth('ViewItemDateOnInvoicePrintOut')">Date</th>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Description</th>
                        <th class="p-tiny">User</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny text-right">Unit Cost</th>
                        <th class="p-tiny text-right">Total</th>
                    </tr>
                </thead>
                <tfoot class="text-xs">
                      <tr>
                        <th class="p-tiny"></th>
                        <th class="p-tiny"   v-if="$root.checkAuth('ViewItemDateOnInvoicePrintOut')"></th>
                          <th class="p-tiny"></th>
                          <th class="p-tiny"></th>
                          <th class="p-tiny"></th>
                          <th class="p-tiny"></th>
                          <th class="p-tiny"></th>
                          <th class="p-tiny text-right font-bold">Totals: {{ totalInsuranceAmt | numberFormat }}</th>
                      </tr>
                </tfoot>
                <tbody class="text-xs">
                    <tr v-for="(invoiceItem, idx) in invoice.invoiceItems" :key="idx">
                        <td class="p-tiny">{{ invoiceItem.invoiceDetailID }}</td>
                        <td class="p-tiny" v-if="$root.checkAuth('ViewItemDateOnInvoicePrintOut')">{{ invoiceItem.date|dateFormat }}</td>
                        <td class="p-tiny">{{ invoiceItem.item }}</td>
                        <td class="p-tiny">{{ invoiceItem.description }}</td>
                        <td class="p-tiny">{{ invoiceItem.userName }}</td>
                        <td class="p-tiny">{{ invoiceItem.qty }}</td>
                        <td class="p-tiny text-right">{{ invoiceItem.charge | numberFormat }}</td>
                        <td class="p-tiny text-right">{{ invoiceItem.insuranceAmountPaid | numberFormat }}</td>
                    </tr>
                </tbody>
            </table>
        </div> 
        <div class="w-full my-1 text-right mx-1">
      <h5 class="text-sm">
        Served By:   {{ invoice.postedBy}}
      </h5>
    </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs mr-8 rounded" 
        @click="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
    <button 
        class="btn-info btn-sm text-xs mr-8 rounded" 
        @click="printInvoiceReceipt">
            <i class="fa fa-print"></i> Print Invoice</button>
    <!-- <button 
        class="btn-primary btn-sm text-xs rounded" 
        @click.prevent="printInvoiceDetails">
            <i class="fa fa-print"></i> Print Invoice</button> -->
  </template>
</tail-modal>
</template>